import ImageSlider from "../common/ImageSlider";
import Image1 from '../../assets/products/VoterSync/VS-Appointments.jpg'
import Image2 from '../../assets/products/VoterSync/VS-Voters.jpg'
import Image3 from '../../assets/products/VoterSync/VS-Works.jpg'
import Image4 from '../../assets/products/VoterSync/VS-Users.jpg'
import Image5 from '../../assets/products/VoterSync/VS-Polls.jpg'
import Image6 from '../../assets/products/VoterSync/VS-Reports.jpg'
import Image7 from '../../assets/products/VoterSync/VS-Home.jpg'
import './index.css'
import { Fade, Slide } from "react-awesome-reveal";
import votersync_about from '../../assets/VoterSync-about.svg'

import VotersIcon from "../../assets/VoterSync/Modules/voting-box.png"
import AuditIcon from "../../assets/VoterSync/Modules/audit.svg"
import AppointmentsIcon from "../../assets/VoterSync/Modules/apppointment.svg"
import BirthdayIcon from "../../assets/VoterSync/Modules/birthday.png"
import PollsIcon from "../../assets/VoterSync/Modules/electionPolls.svg"
import ReportsIcon from "../../assets/VoterSync/Modules/report.png"
import UsersIcon from "../../assets/VoterSync/Modules/users.png"
import WorksIcon from "../../assets/VoterSync/Modules/works.svg"

import Video1 from '../../assets/VoterSync/Videos/VoterDashboardVideo.mp4'
import Video2 from '../../assets/VoterSync/Videos/WorksModuleVideo.mp4'
import Video3 from '../../assets/VoterSync/Videos/ReportsTabVideo.mp4'
import PlayIcon from '../../assets/play-btn.svg'

// import VThumb1 from '../../assets/VoterSync/Videos/vthumb_Voters.svg'
// import VThumb2 from '../../assets/VoterSync/Videos/vthumb_Works.svg'
// import VThumb3 from '../../assets/VoterSync/Videos/vthumb_Reports.svg'

import { uniqueId } from "lodash";
import MultiCarousel from "../common/MultiCarousel";
import { useState } from "react";
import { Dialog, IconButton } from "@mui/material";
import Contact from "../web_development/Contact";
import GotoTop from "../common/GotoTop";

const VThumb1 = Image2
const VThumb2 = Image3
const VThumb3 = Image6

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 2
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2
  },
  tablet: {
    breakpoint: { max: 1024, min: 575 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 575, min: 0 },
    items: 1
  }
};

const VoterSync = () => {
  const data = [
    {
      img: Image7,
      alt: 'Image7'
    },
    {
      img: Image1,
      alt: 'Image1'
    },
    {
      img: Image5,
      alt: 'Image5'
    },
    {
      img: Image2,
      alt: 'Image2'
    },
    {
      img: Image3,
      alt: 'Image3'
    },
    {
      img: Image4,
      alt: 'Image4'
    },
  ]

  const json = [
    {
      title: <>Voter Registration</>,
      description: <>Easily register and update voter information with secure data handling practices.</>
    },
    {
      title: <>Report Generation</>,
      description: <>Access accurate, up-to-date voter database statistics and reports.</>
    },
    {
      title: <>Work Module</>,
      description: <>Analyze the data of different works logged for voters.</>
    },
    {
      title: <>Audits & Appointments</>,
      description: <>Special modules developed to bring digital transformation to the conventional on-paper works</>
    },
    {
      title: <>User-Friendly Interface</>,
      description: <>An intuitive design for easy navigation by administrators and coordinators.</>
    },
    {
      title: <>Customizable Features</>,
      description: <>Tailor the platform to meet specific client needs and requirements</>
    },
  ]

  const modules = [
    {
      title: "Voters",
      img: VotersIcon,
    },
    {
      title: "Appointments",
      img: AppointmentsIcon,
    },
    {
      title: "Works",
      img: WorksIcon,
    },
    {
      title: "Audits",
      img: AuditIcon,
    },
    {
      title: "Users",
      img: UsersIcon,
    },
    {
      title: "Reports",
      img: ReportsIcon,
    },
    {
      title: "Birthday",
      img: BirthdayIcon,
    },
    {
      title: "Election Polls",
      img: PollsIcon,
    },
  ]


  const videoData= [
    {
      node:<RenderVideo
        title={'Voter'}
        src={Video1}
        poster={VThumb1}
      />
    },
    {
      node:<RenderVideo
        title={'Works'}
        src={Video2}
        poster={VThumb2}
      />
    },
    {
      node:<RenderVideo
        title={'Reports'}
        src={Video3}
        poster={VThumb3}
      />
    },
  ]

  const onPress = (e) => {
    e.preventDefault();
    const target = window.document.getElementById(
      e.currentTarget?.href.split("#")[1]
    );
    
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return <div className="pt-4">
    <div className="md:flex bg-votersync md:h-[400px] ">
      <section className="flex flex-col justify-center">
        <div className="text-center vs-title text-6xl md:text-7xl flex justify-center font-semibold">
          <Fade triggerOnce>
            <p className="w-fit text-[var(--dark-blue)] leading-[1.5]">
              VoterSync
            </p>
          </Fade>
        </div>
        <div className="text-center font-bold tracking-widest text-xl md:text-2xl bg-[var(--dark-blue)] text-white py-2">
          <Fade
            triggerOnce
            delay={400}
          >
            <span>
              Streamlining Voter data & build connection with voter
            </span>
          </Fade>
        </div>
      </section>
      <div className="md:w-[65%] slider-container bg-[var(--dark-blue)] flex justify-center">
        <div className="w-full max-md:mb-[40px]">
          <Fade
            triggerOnce
            className="h-full relative"
            delay={600}
          >
            <ImageSlider
              data={data}
            />
          </Fade>
        </div>
      </div>
    </div>

    <div className="w-full px-5 sm:max-lg:px-2 my-7 sm:my-14">
      <p className="text-center mb-4 md:mb-0 font-notosans text-3xl sm:text-4xl font-bold text-[#333e49]">
        <Fade
          triggerOnce
          className="h-full relative"
          delay={610}
        >
          About Our Platform
        </Fade>
      </p>

      <div className="lg:flex lg:gap-2 w-full">
        <div className="w-full">
          <div className="w-full">
            <Fade
              triggerOnce
              className="h-full relative"
              delay={610}
            >
              <img src={votersync_about}
                className="lg:min-w-[600px] animate-on-appear"
              />
            </Fade>
          </div>
        </div>

        <div >
          <Fade
            triggerOnce
            className="h-full relative"
            delay={650}
          >
            <p className="flex flex-col justify-center vs-about-us-content h-full font-notosans text-md sm:text-xl font-semibold text-[#333e49]">
              <p className="mb-6">
                The Voter Management System is designed to bring efficiency, transparency, and security to the voter information loggin process.
              </p>
              <p className="mb-6">
                Our mission is to empower democracy by providing tools that make managing voter databases, creating reports, reporting results
                and organizing appointments seamless for administrators.
              </p>
              <p>
                <a className="text-blue-800 underline" href="#contact" onClick={onPress}>
                  Join us
                </a>&nbsp;
                in shaping the future of
                participatory governance.
              </p>
            </p>
          </Fade>
        </div>
      </div>
    </div>

    <div className="keyh-main-wrapper w-full px-5 sm:px-24 sm:my-14">

      <div className="keyh-wrapper">
        <div className='keyh-box py-4 sm:py-6'>

          <p className="text-center mb-4 md:mb-8 font-notosans text-3xl sm:text-4xl font-bold text-[#333e49]">
            <Fade
              triggerOnce
              className="h-full relative"
              delay={700}
            >
              Salient Features
            </Fade>
          </p>

          <div className='keyh-content pt-4'>
            {
              json.map((item, index) => {

                return <div className="appear-on-scroll content-wrapper" key={`${index}`}>
                  <Fade
                    triggerOnce
                    delay={index * 150}
                  >
                    <div className='line'>
                      <div className="">
                        <p className="title text-[1.3rem] md:text-[2.1vw]">
                          <div className="w-fit text-content">{item.title}</div>
                        </p>
                        <p className="description w-full text-[1rem] md:text-[1.7vw]" data-text={item.description}>{item.description}</p>
                      </div>
                    </div>
                  </Fade>
                </div>
              })
            }
          </div>
        </div>
      </div>
    </div>

    <div className=" w-full px-5 sm:px-24 pt-1 pb-5 md:pb-10 sm:my-14 gallery-section">

      <div className='py-4 sm:py-6'>
        <p className="text-center mb-4 md:mb-8 font-notosans text-3xl sm:text-4xl font-bold text-white">
          <Fade
            triggerOnce
            className="h-full relative"
            delay={700}
          >
            Gallery
          </Fade>
        </p>
      </div>

      <div>
        <MultiCarousel
          data={videoData}
          responsiveSettings={responsive}
          carouselContainerClassname="video-carousel-container"
          listItemClassname="video-list-item"
        />
      </div>
    </div>

    <div className=" w-full px-5 sm:px-24 mt-6 sm:my-14">

      <div className='py-4 sm:py-6'>
        <p className="text-center mb-4 md:mb-8 font-notosans text-3xl sm:text-4xl font-bold text-[#333e49]">
          <Fade
            triggerOnce
            className="h-full relative"
            delay={700}
          >
            Modules integrated in VoterSync
          </Fade>
        </p>
      </div>

      <div>
        <div>
          <div className="modules-grid">
            {
              modules.map((obj, index) => {
                return <div className="modules-card bg-[var(--dark-blue)]" key={uniqueId()}>
                  <Slide
                    triggerOnce
                    direction="up"
                    delay={index * 40}
                  >
                    <div className="img-wrap flex justify-center appear-on-scroll">
                      <img
                        src={obj.img}
                        alt="img"
                        className="bg-white border border-t border-b-0  border-gray-400 "
                      />
                    </div>
                    <div className="title text-center pb-2 pt-[4px] text-xs lg:text-lg tracking-widest font-semibold text-white">
                      {obj.title}
                    </div>
                  </Slide>
                </div>
              })
            }
          </div>
        </div>
      </div>

      <div>
        <Fade
          triggerOnce
          className="h-full relative"
          delay={700}
        >
          <Contact
          />
        </Fade>
      </div>

    </div>

    <GotoTop />

  </div>
}
const RenderVideo = ({
  title,
  src,
  poster
}) => {

  const [playing, setPlaying] = useState(false)

  const handlePlay = () => {
    setPlaying(true)
  }

  const closePreview = () => {
    setPlaying(false)
  }

  return <>
    <div className="z-[2] video-title bg-[var(--dark-blue)] border-2 border-orange-400 min-w-[30ch] text-center pt-1 lg:pt-2 pb-1 text-xs lg:text-lg font-bold text-white absolute right-[-12ch] top-[1ch] tracking-wider rotate-45">
      {
        title
      }
    </div>
    <div
      className="video-wrapper relative overflow-hidden "
    >
      <img
        src= {PlayIcon}
        alt="play"
        title="click to Play"
        className="play-icon absolute w-[40px] h-[40px] lg:w-[60px] lg:h-[60px] bg-slate-200 rounded-[50vw] shadow-lg"
        onClick={handlePlay}
        />
      <img
        src= {poster}
        alt="thumbnail"
        className="max-sm:min-h-[100px] max-sm:min-w-[150px]"
        title="click to Play"
        onClick={handlePlay}
      />
    </div>

    {playing && (
      <Dialog
        sx={{
          zIndex: '100000',
        }}
        open={playing}
        onClose={closePreview}
        maxWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <IconButton
          onClick={closePreview}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'black',
            backgroundColor: 'white',
            border: '1px solid black',
            paddingInline: '10px',
            zIndex: 2,
          }}
        >
          <button
            className='leading-[1]'
            title="close"
          >
            ✕
          </button>
        </IconButton>

        <div className='p-1 lg:p-6 bg-slate-200 overflow-visible'>
          <div className='relative overflow-visible'>
            <video
              src={src}
              controls
              muted
            />
          </div>
        </div>
      </Dialog>
    )}
  </>
}

export default VoterSync;